import axios from "axios";

const localhost = "https://api.einsteins.lv/student-api/";
const studentApiBaseUrl = process.env.REACT_APP_STUDENT_API_BASE_URL
    ? process.env.REACT_APP_STUDENT_API_BASE_URL
    : localhost;

const http = axios.create({
    baseURL: studentApiBaseUrl,
    headers: {
        Accept: "application/json"
    },
});

http.interceptors.response.use( // this global fighter jet intercepts all "Unauthenticated" 401 api responses - if yes, cleans storage and bombards user out to login page
    response => response,
    error => {
        const status = error.response?.status;
        const message = error.response?.data?.message;

        if (status === 401 || message === "Unauthenticated.") {
            //console.warn("Pew pew fighter jet shoots at 401");
            localStorage.clear?.();
            sessionStorage.clear?.();

            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);

window["http" as any] = http as any;

export { http };
